import BrandIcon from 'components/global/Icon/Brand';
import type { BrandIconName } from 'components/global/Icon/Brand/brand-icons';
import {
  Benefit,
  Card,
  Cards,
  CardText,
  Heading,
  Section,
  Timeframe,
} from './styles';
import { withFootnotes } from '../footnotes';

export interface BenefitItem {
  icon: BrandIconName;
  timeframe: string;
  benefit: string;
}

interface BenefitsProps {
  id?: string;
  heading: string;
  items: BenefitItem[];
}

const Benefits = ({ id, heading, items }: BenefitsProps) => (
  <Section id={id}>
    <Heading>{withFootnotes(heading)}</Heading>
    <Cards>
      {items.map(({ icon, timeframe, benefit }) => (
        <Card key={timeframe}>
          <BrandIcon name={icon} size='md' color='dark' />
          <CardText>
            <Timeframe>{timeframe}</Timeframe>
            <Benefit>{withFootnotes(benefit)}</Benefit>
          </CardText>
        </Card>
      ))}
    </Cards>
  </Section>
);

export default Benefits;
